import React, { Children } from 'react'

import SettingVerticalTabs from 'components/Utils/SettingVerticalTabs'

export type ModalTabsProps = {
  style?: React.CSSProperties
  children: (React.ReactElement | false)[]
  currentTabId: string
  setCurrentTabId: (id: string) => void
  renderHeader: () => React.ReactNode
}
export default function ModalTabs({
  style,
  children,
  currentTabId,
  setCurrentTabId,
  renderHeader = () => null,
}: ModalTabsProps) {
  const tabs = Children.map(children, child => {
    if (!child) {
      return false
    }
    const { tabId, tabLabel, tabIcon, tabDisabled } = child.props

    return {
      id: tabId,
      title: tabLabel,
      icon: tabIcon,
      disabled: tabDisabled,
      isActive: tabId === currentTabId,
      onClick: () => setCurrentTabId(tabId),
    }
  }).filter(Boolean)

  const header = renderHeader()

  const currentTab = Children.toArray(children).find(
    child => child && child.props.tabId === currentTabId
  )

  return (
    <div className="flexbox">
      <div
        className="flexbox overflow-hidden flexbox-column border-right-medium border-shade-50"
        style={{
          minWidth: '200px',
          borderTopLeftRadius: '4px',
          ...style,
        }}
      >
        <SettingVerticalTabs tabs={tabs} />
      </div>
      <div className="flexbox-grow">
        {header && (
          <div className="border-bottom-medium border-shade-50 padding-vertical-medium padding-left-largest padding-right-medium">
            {header}
          </div>
        )}
        {currentTab}
      </div>
    </div>
  )
}

export type ModalTabProps = {
  tabId: string
  tabLabel: string
  tabIcon: React.ComponentType<any>
  children: React.ReactNode
}
export function ModalTab({ children }: ModalTabProps) {
  return <>{children}</>
}
